var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownload2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.75C9.41421 8.75 9.75 8.41421 9.75 8C9.75 7.58579 9.41421 7.25 9 7.25L9 8.75ZM17 7.25C16.5858 7.25 16.25 7.58579 16.25 8C16.25 8.41421 16.5858 8.75 17 8.75L17 7.25ZM22.25 12L22.25 17L23.75 17L23.75 12L22.25 12ZM19 20.25L7 20.25L7 21.75L19 21.75L19 20.25ZM3.75 17L3.75 12L2.25 12L2.25 17L3.75 17ZM7 8.75L9 8.75L9 7.25L7 7.25L7 8.75ZM17 8.75L19 8.75L19 7.25L17 7.25L17 8.75ZM3.75 12C3.75 10.2051 5.20507 8.75 7 8.75L7 7.25C4.37665 7.25 2.25 9.37665 2.25 12L3.75 12ZM7 20.25C5.20507 20.25 3.75 18.7949 3.75 17L2.25 17C2.25 19.6234 4.37665 21.75 7 21.75L7 20.25ZM22.25 17C22.25 18.7949 20.7949 20.25 19 20.25L19 21.75C21.6234 21.75 23.75 19.6234 23.75 17L22.25 17ZM23.75 12C23.75 9.37665 21.6234 7.25 19 7.25L19 8.75C20.7949 8.75 22.25 10.2051 22.25 12L23.75 12Z",
    fill: "#717171"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13L12.2929 15.2929C12.6834 15.6834 13.3166 15.6834 13.7071 15.2929L16 13",
    stroke: "#717171",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15L13 3",
    stroke: "#717171",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownload2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/download-2.fc36000bbf8ada3da5b6de5527572da3.svg";